import { render, staticRenderFns } from "./Preferencias.vue?vue&type=template&id=08a2a575&"
import script from "./Preferencias.vue?vue&type=script&lang=js&"
export * from "./Preferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports